// FIXME: Lintar componente, não feito por motivo de hotfix
import { OnInit, AfterViewInit, Component } from '@angular/core';
import { skip, first } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import  * as BlipWidget from './../../scripts/blip-chat-widget';

import { AppState } from '../../interfaces/app-state.interface'; // shared\interfaces\app-state.interface.ts
import { ChatBlipControllerService } from './chat-blip-control.service';
import { DialogsService } from '../../services/dialogs.service';
import { SettingsService } from '../../services/settings/settings.service';

@Component({
    selector: 'chat-blip',
    template: '',
    providers: [ChatBlipControllerService, DialogsService]
})
export class ChatBlipComponent implements OnInit {
    private Store$;

    // Link auxiliar: https://portal.blip.ai/application/detail/chatbothub/channels/blipchat2.0
    public blipComponent;
    private emAtendimentoHumano : boolean = false; 
    // Para pegar esse ID, você precisa ter acesso ao "ChatBot - Hub" que está vinculado à conta da Toro em:
    // Link auxiliar > Canais > BLiP Chat > Instalação
    // Copiar o código que está localizado dentro do código de embed.
    private appKey = this.settingsService.getConfigurationKeyValue('blip').appKey;
    
    // BotId - Indicando qual a referência do bot onde está sendo registrado os contatos e comandos.
    private botId = this.settingsService.getConfigurationKeyValue('blip').appBotId;
    
    // BotUrl - Url do CustomCommonUrl.
    private botUrl = this.settingsService.getConfigurationKeyValue('blip').appBotUrl;
                                            
    // CSS que utilizamos pra deixar o chatbot do BLiP com a cara da Toro :D
    // Só é necessário para estilizar dentro do bot - no caso podemos estilizar dentro da própria plataforma em:
    // Link auxiliar > Canais > BLiP Chat > Configurações
    // Em "Cores" pode-se alterar as duas cores principais do chat.
    // ATENÇÃO: Precisa ser uma string para que possa funcionar no método que chama CSS estilizado do BLiP.
    private cssText = `
        #blip-chat-header,
        #message-input .send-button,
        .blip-message-group .blip-card-group>:first-child .bubble.right,
        .blip-message-group .blip-card-group>:not(:first-child) .bubble.right {
            background-color: #00000 !important;
        }
        .select .options li {
            background-color: rgb(204, 239, 246) !important;
            color: rgb(0, 173, 210) !important;
            border: 1px solid rgb(0, 173, 210) !important;
        }
        .select .next,
        .select .prev {
            color: #CC0000 !important;
        }
    `;

    constructor(
        private store: Store<AppState>,
        private chatBlipControlService : ChatBlipControllerService,
        private dialogsService: DialogsService,
        private settingsService: SettingsService
    ) {
        this.Store$ = this.store;
    }

    public ngOnInit() {
        let userCblc = null;

        this.Store$
            .select(({ authentication }) => authentication.currentUser)
            .filter(currentUser => !!currentUser && !!currentUser.cblc)
            .first()
            .subscribe(data => userCblc = data.cblc);

        this.Store$
            .select(state => state.userProfile)
            .pipe(skip(1))
            .subscribe(data => {
                if ( data.user != null && data.user != undefined) {
                    if (this.blipComponent.widget != undefined && this.blipComponent.widget.authConfig != undefined) {  
                        this.blipComponent.destroy()
                    }
                    
                    // Adiciona CBLC adquirido da store authentication no objeto da store user  
                    data.user.cblc = userCblc; 

                    this.mountBlipComponent(this.appKey, this.cssText, data.user);
                }
            });
    }

    public ngAfterViewInit() {
        this.mountBlipComponent(this.appKey, this.cssText, null);
    }

    /**
     * Método que monta o objeto do BLiP.
     * @param appKey Chave da nossa aplicação
     * @param cssText Ele precisa estar como string, senão o builder do BLiP não executa.
     */
    private mountBlipComponent(appKey: string, cssText: string, user) {

        if (user != null && user.email != undefined) {
            // Prepare user payload
            const userPayload = this.mountUserPayload(user);
            
            // Initialize BlipChat component
            const builder = new BlipWidget.BlipChat()
                .withAppKey(appKey)
                // tslint:disable-next-line:object-literal-key-quotes
                .withButton({'color': '#CC0000', 'icon': ''})
                .withTarget('chat')
                .withAuth({
                    authType: BlipWidget.BlipChat.DEV_AUTH,
                    userIdentity: user.email,
                    userPassword: 'MTIzNDU2',
                })   
                .withAccount(userPayload)
                .withCustomCommonUrl(this.botUrl)

                builder.build()

                builder.withEventHandler(BlipWidget.BlipChat.ENTER_EVENT, () => {
                    if (builder != null && builder.widget != undefined) {
                        this.dialogsService.closeAll();
                    }
                })

                builder.withEventHandler(BlipWidget.BlipChat.LOAD_EVENT, () => {
                    let userIdentitySDK = `${ encodeURIComponent(user.email) }${this.botId}`

                    this.chatBlipControlService.initWSConnection();
                    
                    if (builder != null && builder.widget != undefined) {
                        setInterval(() => {
                            this.chatBlipControlService.getContextVariable('emAtendimento', userIdentitySDK);
                  
                            if (this.chatBlipControlService.messageReceived != null) {
                                if (this.chatBlipControlService.messageReceived.resource != null)
                                    this.emAtendimentoHumano = (this.chatBlipControlService.messageReceived.resource == "True") ? true : false;
                            }
                        }, 2350)

                        setTimeout(() => {
                            this.chatBlipControlService.updateContact(userPayload);
                        }, 2350)
                    }
                })

                builder.withEventHandler(BlipWidget.BlipChat.LEAVE_EVENT, () => {
                    if (builder != null && builder.widget != undefined ) {
                        if (this.emAtendimentoHumano) {
                            this.dialogsService.confirmAction(
                                    'Você realmente quer encerrar a conversa com o(a) assessor(a)?',
                                    'Se você sair da conversa, este atendimento será encerrado.',
                                    'SAIR',
                                    'VOLTAR',
                                ).subscribe((data) => {
                                    if(data) {
                                        builder.sendMessage({
                                            "type": "text/plain",
                                            "content": `Blip Widget => Cliente encerrou o chat`,
                                            "metadata":{
                                                "#blip.hiddenMessage": true
                                            }
                                        })
                                    } else if (!data && !builder.widget.isOpen) {
                                        builder.toogleChat()
                                    }
                                })
                        }
                    } 
                })

                if (builder != null && builder.widget != undefined) {
                    try {
                        // Adiciona event listener para disparo de eventos no geral
                        window.removeEventListener('BlipWidget.event', null, false);
                        window.addEventListener('BlipWidget.event', (event : CustomEvent) => {
                            builder.sendMessage({
                                "type": "text/plain",
                                "content": `${(event.detail != null) ? `BlipWidget.event.${event.detail}` : 'BlipWidget.event'}`,
                                "to": `botfilho@msging.net/az-iris1`,
                                "metadata":{
                                    "#blip.hiddenMessage": true
                                }
                            })
                            
                            if (!builder.widget.isOpen) {
                                builder.toogleChat()
                            }
                        })

                    } catch (ex) { throw ex; }
                }

            this.blipComponent = builder;
        } else {
            
            const builder = new BlipWidget.BlipChat()
                .withAppKey(appKey)
                // tslint:disable-next-line:object-literal-key-quotes
                .withButton({'color': '#CC0000', 'icon': ''})
                .withTarget('chat')
                .withCustomCommonUrl(this.botUrl)
                .withoutHistory()

                builder.build();
                
                // O CSS está comentado porque já conseguimos alterar as cores principais dentro da plataforma
                // .withCustomStyle(cssText)
                this.blipComponent = builder;
        }
    } 

    public mountUserPayload(user) : Object {

        const userIdentitySDK = `${ encodeURIComponent(user.email) }${this.botId}`

        return {
            identity: userIdentitySDK, 
            fullName: user.name,
            email: user.email,
            phoneNumber: `${user.phoneAreaCode} ${user.phoneNumber}`,
            extras: {
                gender: (user.genderDescription != null) ? user.genderDescription : 'Indefinido',
                tag: 'Origem - Browser',
                cblc: (user.cblc != null) ? user.cblc : 'SEM CBLC',
                cpfcnpj: (user.cpfcnpj != null) ? user.cpfcnpj : 'SEM CPF/CNPJ',
                patrimonioAtivo: (user.movablePropertiesValue != null) ? user.movablePropertiesValue : 'SEM PATRIMONIO ATIVO MÓVEL',
                salario: (user.monthlySalary != null) ? user.monthlySalary : 'SEM SALARIO MENSAL'
            }
        };
    }
}
